package com.wintermar.inspection.feature.presentation.inspection.answer.widget.header

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextBodyXLarge
import com.wintermar.inspection.core.ui.component.button.Button
import com.wintermar.inspection.core.ui.component.button.IconButton
import com.wintermar.inspection.core.ui.component.button.iconButtonContent
import com.wintermar.inspection.core.ui.component.button.variant.ButtonVariant
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.widget.HeaderWideContainer
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_arrow_left_line
import inspection.composeapp.generated.resources.ic_search
import inspection.composeapp.generated.resources.save_progress
import org.jetbrains.compose.resources.stringResource

@Composable
fun HeaderWide(
    templateName: String,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onClose: () -> Unit,
    onSaveProgress: () -> Unit,
    onSearch: () -> Unit
) {
    val size = dimension.size.size7
    HeaderWideContainer(horizontalPadding = dimension.spacing.space6) {
        IconButton(
            icon = Res.drawable.ic_arrow_left_line,
            backgroundColor = color.surface.neutral.subtlest.default,
            tint = color.icon.subtle,
            contentValue = iconButtonContent().copy(
                borderColor = color.border.default,
                borderWidth = 1.dp,
                width = size,
                height = size
            ),
            onClick = {
                onClose()
            }
        )
        TextBodyXLarge(templateName, bold = true, modifier = Modifier.weight(1f))
        IconButton(
            icon = Res.drawable.ic_search,
            backgroundColor = color.surface.neutral.subtlest.default,
            tint = color.icon.subtle,
            contentValue = iconButtonContent().copy(
                width = size,
                height = size
            ),
            onClick = {
                onSearch()
            }
        )
        Button(
            buttonVariant = ButtonVariant.SmallGhost,
            text = stringResource(Res.string.save_progress),
            onClick = { onSaveProgress() }
        )
    }
}
